import Collection from '../../collection';
import Workgroup from '../../model/refbooks/workgroup';





export default Collection.extend( {
	endpoint: 'workgroups/list?apiVersion=2.0&limit=1000000000',
	responseAt: 'items',
    model: Workgroup,
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/workgroups.js